module.exports = __webpack_public_path__ + "img/map_toilet_4@2x.af2e2abb.png";